import $ from "jquery";
import "slick-carousel";

class WidgetECFSliderListPeople extends elementorModules.frontend.handlers.Base {
    getDefaultSettings() {
        return {
            // Tạo variables class cần DOM trong widget
            selectors: {
                slider_box_list: '.carousel-list-people',
                slider_list_item: '.list-item-people'
            },
        };
    }

    getDefaultElements() {
        const selectors = this.getSettings( 'selectors' );
        return {
            // Tạo variables DOM trong widget
            $slider_box_list: this.$element.find( selectors.slider_box_list ),
            $slider_list_item: this.$element.find( selectors.slider_list_item ),
        };
    }
    

    bindEvents() {
        let slider_box_list = this.elements.$slider_box_list[0];
        let widthMobile = $(window).width();
        let widthDevice = window.outerWidth;
        let lengthSliderItem = this.elements.$slider_list_item.length;
        if(widthMobile < 990){ 
            $(slider_box_list).slick({
                slidesToShow: 2,
                slidesToScroll: 2,
                focusOnSelect: true,
                infinite: false,
                speed: 500,
                fade: false,
                nextArrow: false,
                prevArrow: false,
                dots: true,
                responsive: [
                    {
                    breakpoint: 768,
                    settings: {
                        centerMode: false,
                        slidesToShow: 2,
                        slidesToScroll: 2,
                        }
                    },
                    {
                        breakpoint: 762,
                        settings: {
                            centerMode: false,
                            slidesToShow: 1,
                            slidesToScroll: 1,
                            centerMode: true,
                            centerPadding: "12px",
                            }
                        },
                ]
            })
        }        
        if(lengthSliderItem%2 != 0 && (widthDevice < 1024 && widthDevice > 767)){
            $(slider_box_list).slick('slickAdd', '<div><div><div class="slick-item"></div></div></div>')
          }
    }
}

jQuery( window ).on( 'elementor/frontend/init', () => {
    const addHandler = ( $element ) => {
        elementorFrontend.elementsHandler.addHandler( WidgetECFSliderListPeople, {
            $element,
        } );
    };
    // efc_form_donate ->Name widget register in php
    elementorFrontend.hooks.addAction( 'frontend/element_ready/ecf_list_people.default', addHandler );
} );

